// extracted by mini-css-extract-plugin
export default {"arrow_up":"TriangleArrow_arrow_up__nMf7w","arrow_down":"TriangleArrow_arrow_down__jJ4By"};